<template>
	<router-view :key="JSON.stringify(relevantRouteParams)" />
</template>

<script>
export default {
	name: 'PlacementRoot',
	computed: {
		routeParams() {
			return this.$route.params;
		},
		routeParamsKeysThatRequireReRender() {
			return ['featureType', 'serviceSlug', 'serviceWorkspaceId'];
		},
		relevantRouteParams() {
			let relevant = {};
			this.routeParamsKeysThatRequireReRender.forEach((key) => {
				relevant = { ...relevant, [key]: this.routeParams[key] };
			});
			return relevant;
		},
	},
};
</script>

<style lang="scss" scoped></style>
